<app-layout [title]="form.definition()?.name || ''" [client]="form.client()?.name ?? ''">
  <div class="px-4 pb-48">
    @if (
      loadedData() &&
      loadedData().employee &&
      loadedData().employee.name !== '' &&
      loadedEmployees() &&
      loadedEmployees().length === 0
    ) {
      <div class="py-2">
        <div class="bg-white rounded-xl p-4 border-l-primary border-l-6">
          <p class="font-bold">{{ loadedData().employee.name }}</p>
          <p class="text-sm">
            <a href="mailto:{{ loadedData().employee.email }}">{{ loadedData().employee.email }}</a>
            <br />
            <a href="tel:{{ loadedData().employee.phone }}">{{ loadedData().employee.phone }}</a>
          </p>
        </div>
      </div>
    }

    @if (loadedEmployees() && loadedEmployees().length > 0) {
      @for (employee of loadedEmployees(); track $index) {
        <div class="py-2">
          <div class="bg-white rounded-xl p-4 border-l-primary border-l-6">
            <p class="font-bold">{{ employee.name }}</p>
            <p class="text-sm">
              <a href="mailto:{{ employee.email }}">{{ employee.email }}</a>
              <br />
              <a href="tel:{{ employee.phone }}">{{ employee.phone }}</a>
            </p>
          </div>
        </div>
      }
    }

    <div class="flex flex-col bg-white rounded-xl p-4 gap-2 mt-2" [formGroup]="form.form">
      @if (currentStepTitle !== '') {
        <div class="border-b-2 border-b-gray-300 py-2">
          <h1 class="font-bold text-xl">{{ currentStepTitle }}</h1>
        </div>
      }

      @for (field of currentFields(); track field.name) {
        @if (!field.type.includes('input:') || form.get(field.name)) {
          @switch (field.type) {
            @case ('input:externals_signatures') {
              @if (field.inputName) {
                @for (item of getExternals(field.inputName); track $index) {
                  <fieldset class="fieldset w-full">
                    <legend class="fieldset-legend">{{ item }}</legend>
                    <app-signature-pad
                      (signatureChanged)="externalAddSignature(field.name, item, $event)"
                    ></app-signature-pad>
                  </fieldset>
                } @empty {
                  <fieldset class="fieldset w-full">
                    <legend class="fieldset-legend">Pas de personnes externes présentes.</legend>
                  </fieldset>
                }
              } @else {
                <p>Erreur: Pas d'input avec ce nom</p>
              }
            }

            @case('input:epis') {
              <epi-selector
                [formControlName]="field.name"
                [label]="field.label">
              </epi-selector>
            }
            @case ('input:externals') {

              <fieldset class="fieldset bg-base-100 border-base-300 rounded-box w-full border p-4">
                <legend class="fieldset-legend">{{ field.label }}</legend>
                <label class="label">
                  <input
                    type="checkbox"
                    class="toggle toggle-success"
                    [checked]="showExternals"
                    (change)="showExternals = !showExternals"
                  />
                </label>
              </fieldset>

              @if (showExternals) {
                <fieldset class="fieldset">
                  <legend class="fieldset-legend">{{ field.label }}</legend>
                  <div class="join">
                    <input
                      type="text"
                      placeholder="Ajouter une personne"
                      class="input join-item"
                      [formControlName]="`input_${field.name}`"
                      (keydown.enter)="addExternal(field.name)"
                    />
                    <button
                      type="button"
                      class="btn btn-success join-item"
                      (click)="addExternal(field.name)"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="1em"
                        height="1em"
                        viewBox="0 0 24 24"
                      >
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path
                          fill="currentColor"
                          d="M11.288 20.713Q11 20.425 11 20v-7H4q-.425 0-.712-.288T3 12t.288-.712T4 11h7V4q0-.425.288-.712T12 3t.713.288T13 4v7h7q.425 0 .713.288T21 12t-.288.713T20 13h-7v7q0 .425-.288.713T12 21t-.712-.288"
                        />
                      </svg>
                    </button>
                  </div>
                  <p class="label-text wrap-break-word w-full text-gray-400">
                    {{ field.helper || '' }}
                  </p>

                  <ul class="w-full list bg-base-100 rounded-box shadow-md">
                    @for (item of getExternals(field.name); track $index) {
                      <li class="flex justify-between items-center ps-4">
                        <div class="w-max">
                          {{ item }}
                        </div>
                        <button
                          type="button"
                          class="text-red-400 p-2"
                          (click)="removeExternal(field.name, $index)"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="2em"
                            height="2em"
                            viewBox="0 0 32 32"
                          >
                            <path d="M0 0h32v32H0z" fill="none" />
                            <path
                              fill="currentColor"
                              d="M29 26H12a1 1 0 0 1-.707-.293l-9-9a1 1 0 0 1 0-1.414l9-9A1 1 0 0 1 12 6h17a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1m-16.586-2H28V8H12.414l-8 8z"
                            />
                            <path
                              fill="currentColor"
                              d="M20.414 16L25 11.414L23.586 10L19 14.586L14.414 10L13 11.414L17.586 16L13 20.586L14.414 22L19 17.414L23.586 22L25 20.586z"
                            />
                          </svg>
                        </button>
                      </li>
                    }
                  </ul>
                </fieldset>
              }
            }
            @case ('input:thematique') {
              <div>
                {{ field.label }}
                <select [formControlName]="field.name" id="" class="select">
                  @for (thematique of thematiques$ | async; track thematique._id) {
                    <option
                      [ngValue]="{
                        uuid: thematique._id,
                        name: thematique.name,
                      }"
                    >
                      {{ thematique.name }}
                    </option>
                  }
                </select>
              </div>
            }
            @case ('input:employees') {
              <div>
                <label class="block font-bold mb-2">{{ field.label }}</label>

                @if (employees$ | async; as employeesList) {
                  @if (form.form; as form) {
                    <ng-select
                      [items]="employeesList"
                      bindLabel="name"
                      [multiple]="true"
                      [formControlName]="field.name"
                      placeholder="Sélectionner les employés"
                      [compareWith]="compareEmployees"
                      (change)="changeEmployees()"
                    >
                    </ng-select>
                  }
                }
              </div>
            }
            @case ('input:employee') {
              <app-employee-select-field [parentForm]="form.form" [field]="field" [loadedData]="loadedData"[allowCreation]="field.name === 'employee'" />
            }

            @case ('input:client') {
              @if (!form.get('client')?.value) {
                <fieldset class="fieldset w-full">
                  <legend class="fieldset-legend">{{ field.label }}</legend>
                  <ng-select
                    [formControlName]="field.name"
                    [items]="(clients$ | async) ?? []"
                    bindLabel="name"
                    placeholder="Sélectionner un client..."
                    [compareWith]="compareValueSelect"
                    (change)="clientChange()"
                  >
                  </ng-select>
                  <p class="label-text wrap-break-word w-full text-gray-400">
                    {{ field.helper || '' }}
                  </p>
                </fieldset>
              }
            }

            @case ('input:sous_traitant') {
              <fieldset class="fieldset w-full">
                <legend class="fieldset-legend">{{ field.label }}</legend>
                <ng-select
                  [formControlName]="field.name"
                  [items]="(sousTraitants$ | async) ?? []"
                  placeholder="Tapez pour chercher un sous-traitant..."
                  bindLabel="name"
                  placeholder="Sélectionner un sous-traitant..."
                >
                </ng-select>
                <p class="label-text wrap-break-word w-full text-gray-400">
                  {{ field.helper || '' }}
                </p>
              </fieldset>
            }

            @case ('input:text') {
              <app-input-text
                [label]="field.label"
                [formControlName]="field.name"
                [helper]="field.helper"
              ></app-input-text>
            }
            @case ('input:textarea') {
              <fieldset class="fieldset w-full">
                <legend class="fieldset-legend">{{ field.label }}</legend>
                <textarea class="textarea h-48 w-full" [formControlName]="field.name"></textarea>
                <p class="label-text wrap-break-word w-full text-gray-400">
                  {{ field.helper || '' }}
                </p>
              </fieldset>
            }

            @case ('element:link') {
              <a (click)="logic(field)" class="text-red-500 mb-3">{{ field.label }}</a>
            }

            @case ('input:checkboxs+size') {
              <div>
                <!-- <p>{{ field.label }}</p> -->
                <ul class="flex flex-col gap-2">
                  @for (item of field.items; track $index) {
                    <li>
                      <input type="checkbox" (change)="onCheckboxCheck(field.name, item, $event)" />
                      {{ item }}

                      <fieldset class="fieldset w-full">
                        <legend class="fieldset-legend">Taille</legend>
                        <input
                          type="text"
                          class="input w-full"
                          [formControlName]="field.name + '_' + $index + '_size'"
                          placeholder="Taille"
                        />
                      </fieldset>
                    </li>
                  }
                </ul>
              </div>
            }

            @case ('input:checkboxs_complexe') {
              {{ field.label }}

              @for (item of field.items; track $index) {
                <fieldset
                  class="fieldset bg-base-100 border-base-300 rounded-box w-full border p-4"
                >
                  <legend class="fieldset-legend"></legend>
                  <label class="label">
                    <input
                      type="checkbox"
                      (change)="onCheckboxCheck(field.name, item.label, $event)"
                    />
                    {{ item.label ? item.label : '' }}
                  </label>
                  <ul>
                    @for (input of item.inputs; track $index) {
                      <li>
                        <fieldset class="fieldset w-full">
                          <legend class="fieldset-legend">{{ input.label }}</legend>
                          <input
                            type="text"
                            class="input w-full"
                            [formControlName]="input.name"
                            placeholder="Taille"
                          />
                        </fieldset>
                      </li>
                    }
                  </ul>
                </fieldset>
              }
            }

            @case ('input:checkbox') {
              <app-input-checkbox
                [formControlName]="field.name"
                [label]="field.label"
              ></app-input-checkbox>
            }

            @case ('element:list') {
              <app-element-list
                [label]="field.label"
                [items]="field.items || []"
              ></app-element-list>
            }

            @case ('input:signature') {
              <fieldset class="fieldset w-full">
                <legend class="fieldset-legend">{{ field.label }}</legend>
                <app-signature-pad [formControlName]="field.name"></app-signature-pad>
                <p class="label-text wrap-break-word w-full text-gray-400">
                  {{ field.helper || '' }}
                </p>
              </fieldset>
            }

            @case ('input:employee_signatures') {
              <p>{{ field.label }}</p>

              @for (employee of getEmployeesToSign(); track $index) {
                <fieldset class="fieldset w-full">
                  <legend class="fieldset-legend">{{ employee.name }}</legend>
                  <app-signature-pad
                    (signatureChanged)="addSignatureToForm($event, employee)"
                  ></app-signature-pad>
                </fieldset>
              } @empty {
                <fieldset class="fieldset w-full">
                  <legend class="fieldset-legend">Pas de salariés présent.</legend>
                </fieldset>
              }
            }

            @case ('input:checkboxs') {
              <fieldset class="fieldset w-full">
                <legend class="fieldset-legend">{{ field.label }}</legend>

                <ul class="flex flex-col gap-2">
                  @for (item of field.items; track $index) {
                    <li class="flex items-center gap-2">
                      <input
                        type="checkbox"
                        class="checkbox checkbox-lg"
                        (change)="onCheckboxCheck(field.name, item, $event)"
                      />
                      <label for="">
                        {{ item }}
                      </label>
                    </li>
                  }
                </ul>
              </fieldset>
            }
            @case ('input:radio') {
              <fieldset class="fieldset w-full">
                <legend class="fieldset-legend">{{ field.label }}</legend>
                @for (item of field.items; track $index) {
                  <div class="flex flex-row gap-2 text-sm text-gray-500">
                    <input
                      type="radio"
                      [formControlName]="field.name"
                      [value]="$index"
                      [id]="item + $index"
                    />
                    <label [for]="item + $index">{{ item }}</label>
                  </div>
                }
              </fieldset>
            }

            @case ('input:switch') {
              <fieldset class="fieldset bg-base-100 border-base-300 rounded-box w-full border p-4">
                <legend class="fieldset-legend">{{ field.label }}</legend>
                <label class="label">
                  <input
                    type="checkbox"
                    checked="checked"
                    class="toggle toggle-success"
                    [formControlName]="field.name"
                  />
                </label>

                @if (
                  field.logic &&
                  field.logic.Oui &&
                  field.logic.Oui.type &&
                  field.logic.Oui.type === 'input:textarea'
                ) {
                  @if (
                    !form.get(field.name)?.value === null || form.get(field.name)?.value === true
                  ) {
                    <div>
                      {{ field.logic.Oui.label }}
                      <textarea
                        class="textarea"
                        [formControlName]="field.logic.Oui.name"
                      ></textarea>
                    </div>
                  }
                }
              </fieldset>
            }

            @case ('input:photos') {
              <div>
                <fieldset class="fieldset">
                  <legend class="fieldset-legend">{{ field.label }}</legend>
                  <input
                    type="file"
                    multiple
                    class="file-input"
                    accept="image/*"
                    capture="environment"
                    (change)="onPhotoAdded(field.name, $event)"
                  />
                </fieldset>

                <div class="flex flex-row flex-wrap gap-2">
                  @for (photo of photos[field.name]; track $index) {
                    <div class="relative aspect-square border rounded-lg overflow-hidden w-37.5">
                      <img [src]="photo.url" class="object-cover w-full h-full" />

                      <button
                        type="button"
                        class="absolute top-1 right-1 bg-red-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs"
                        (click)="onRemovePhoto(field.name, $index)"
                      >
                        ✕
                      </button>
                    </div>
                  }
                </div>
              </div>
            }

            @case ('input:rating') {
              <fieldset class="fieldset w-full">
                <legend class="fieldset-legend">{{ field.label }}</legend>
                <app-rating [name]="field.name" [formControlName]="field.name"> </app-rating>
              </fieldset>
            }

            @default {
              <p>Field non géré : {{ field.type }}</p>
            }
          }
        }
      }
      <div class="flex justify-center">
        <button (click)="goToNextStep()" class="btn btn-xl btn-primary w-min">Suivant</button>
      </div>
    </div>
  </div>
  @if (form.definition() && form.definition()?._id === 'form:causerie' && form.pdfUrl()) {
    <label for="my_modal_6" class="rounded-full right-0 bottom-0 text-7xl fixed">
      <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path
          fill="currentColor"
          d="M12.838 17.638q.362-.363.362-.888t-.362-.888t-.888-.362t-.887.363t-.363.887t.363.888t.887.362t.888-.363M11.05 14.15h1.85q0-.825.188-1.3t1.062-1.3q.65-.65 1.025-1.238T15.55 8.9q0-1.4-1.025-2.15T12.1 6q-1.425 0-2.312.75T8.55 8.55l1.65.65q.125-.45.563-.975T12.1 7.7q.8 0 1.2.438t.4.962q0 .5-.3.938t-.75.812q-1.1.975-1.35 1.475t-.25 1.825M12 22q-2.075 0-3.9-.787t-3.175-2.138T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4T6.325 6.325T4 12t2.325 5.675T12 20m0-8"
        />
      </svg>
    </label>
    <input type="checkbox" id="my_modal_6" class="modal-toggle" />
    <div class="modal" role="dialog">
      <div class="modal-box">
        @if (form.pdfUrl()) {
          <object [data]="form.pdfUrl()" type="application/pdf" class="w-full h-full">
            <p>
              Votre navigateur ne prend pas en charge l'affichage des PDF.
              <a [href]="form.pdfUrl()" download="document.pdf" class="link link-primary"
                >Cliquez ici pour le télécharger</a
              >.
            </p>
          </object>
        } @else {
          <div class="flex items-center justify-center h-full bg-base-200">
            <span class="loading loading-spinner loading-lg">Chargement du PDF...</span>
          </div>
        }
        <div class="w-full flex flex-row justify-between mt-2">
          <label class="btn btn-primary" for="my_modal_6">Fermer</label>
        </div>
      </div>
    </div>
  }
</app-layout>
